/** 日本語 — 暫定（原文英語のまま差し替え可） */
export default {
  brand: {
    linePrimaryZh: '深セン市尚音芯声科技有限公司',
    lineSecondaryEn: 'Shenzhen Shangyin Xinsheng Technology Co., Ltd.',
    singleLine: '深セン市尚音芯声科技有限公司',
  },
  site: {
    documentTitle: '深セン市尚音芯声科技有限公司',
  },
  nav: {
    home: '首页',
    productCenter: '产品中心',
  },
  footer: {
    copyright: '<span style="margin: 0;text-align: center;font-size: 13px;line-height: 1.6;color: #b0b0b0;letter-spacing: 0.02em;">Copyright © 2026 深セン市尚音芯声科技有限公司</span>',
  },
  lang: {
    zh: '简体中文',
    ja: '日本語',
    en: 'English',
  },
  category: {
    sectionTitle: '商品カテゴリー',
    power: 'モバイルバッテリー',
    wearables: 'スマートウェアラブル',
    tws: 'TWSイヤホン',
    speaker: 'Bluetoothスピーカー',
    others: 'その他',
  },
  home: {
    popularTitle: '人気商品',
    popular: {
      p1: 'B18 モバイルバッテリー',
      p2: 'S9 スマートウォッチ',
      p3: 'H15 イヤホン',
      p4: 'BX09 ワイヤレスイヤホン',
    },
    aboutTitle: '会社概要',
    about1_html:
      '<span style="line-height:58px;">深圳市尚音芯声科技有限公司は、2025年12月23日に設立されました。<span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">深圳に拠点を置き、3Cデジタルおよびコンシューマエレクトロニクス分野に特化した革新的なテクノロジー企業です。B向けサプライチェーン価値提供と、C向け日本クロスボーダー事業を両輪としたビジネスモデルを構築しています。</span>確かな産業サービス能力と鋭い市場洞察力を武器に、国内市場と海外市場の全域展開を実現しております。</span>',
    about2_html:
      '<span style="line-height:58px;"><span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">B端市場（法人向け市場）に向けて、</span>当社は高品質なサプライチェーンへの深掘りサービスに注力しています。<span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">整合300家+优质供应商资源，</span>构建了稳定、高效且具品质保障的供应链体系;<span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">300社以上の優良サプライヤーのリソースを統合し、安定性・高効率・品質保証を備えたサプライチェーン体制を構築しております。また、3C製品分野における最先端の技術開発チームを擁し、製品開発からサプライチェーン統合まで、協業企業様にバリューチェーン全体のソリューションを提供いたします。</span>強力な流通チャネル統合力を活かし、国内市場でのサービスを安定させるだけでなく、日本の主要なECプラットフォームや実店舗チャネルにも展開。お客様の国内外での市場開拓を多角的にサポートいたします。</span></span>',
    about3_html:
      '<span style="line-height:58px;"><span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">C端市場（消費者向け市場）を対象に、</span>当社は日本の3C（コンピュータ・家電・通信）オンライン消費市場に深く根差し、日本消費者が求める品質とテクノロジーへの本質的なニーズを的確に捉えています。<span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">現在、日本の主要なEコマースプラットフォームにおいて、当社が出店する店舗リンクはいずれも好調に推移しており、成熟したクロスボーダーEC運営能力とブランド構築力を有しています。</span>これにより、高コストパフォーマンスを備えた質の高い中国製3C製品を持続的に日本市場に提供しています。</span>',
    about4_html:
      '<span style="line-height:58px;">未来，<span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">尚音芯声はBtoC・BtoB両面における連携強化をさらに深め、</span>高品質なサプライチェーンを基盤とし、技術開発を原動力とし、精緻なクロスボーダー運営を手段として、中国と日本の3C産業をつなぎ、産業発展を全プロセスにわたって支援する、新たなリーディングカンパニーを目指してまいります。</span>',
    contactAddressTitle: '会社住所',
    contactAddressText:
      '中国広東省深セン市竜華区大浪街道匯億財富中心703F',
    contactEmailTitle: 'メールアドレス',
    contactEmailText: 'SERVICE@SHANGYINXINSHENG.COM',
  },
  common: {
    details: '詳細',
    contactUs: 'お問い合わせください',
  },
  productCenter: {
    titles: {
      power: 'モバイルバッテリー',
      wearables: 'スマートウェアラブル',
      twsHeadphones: 'TWSイヤホン',
      speaker: 'Bluetoothスピーカー',
      others: 'その他',
    },
  },
  productName: {
    power1: 'B18 モバイルバッテリー',
    power2: 'CDB-006 モバイルバッテリー',
    power3: 'B15 モバイルバッテリー',
    power4: '2005B モバイルバッテリー',
    power5: 'B10 2線式電源',
    power6: 'CDB-006 モバイルバッテリー',
    power7: 'B11 モバイルバッテリー',
    power8: 'V11 マグネット式モバイルバッテリー',
    power9: 'B12 デュアルマグネット急速充電バッテリー',
    smart1: 'S11<br>スマートウォッチ',
    smart2: 'S9<br>スマートウォッチ',
    smart3: 'ZL99J<br>スマートウォッチ',
    smart4: 'Z145<br>スマートウォッチ',
    smart5: 'ZL02CPRO<br>スマートウォッチ',
    smart6: 'ZL73J<br>スマートウォッチ',
    smart7: 'ZL54J<br>スマートウォッチ',
    smart8: 'ZL169<br>スマートウォッチ',
    smart9: 'Z136<br>スマートウォッチ',
    smart10: 'Z123<br>スマートウォッチ',
    tws1: 'T8<br> Bluetoothイヤホン',
    tws2: 'BX09<br> ワイヤレスイヤホン',
    tws3: 'H15<br> Bluetoothイヤホン',
    tws4: 'S13<br> Bluetoothイヤホン',
    tws5: 'S58<br> Bluetoothイヤホン',
    tws6: 'S57<br> Bluetoothイヤホン',
    tws7: 'W09<br> Bluetoothイヤホン',
    tws8: 'E09<br> Bluetoothイヤホン',
    tws9: 'H10<br> デュアルマイクENC',
    tws10: 'T08<br> Bluetoothイヤホン',
    tws11: 'Y12<br> 骨伝導イヤホン',
    tws12: 'S75<br> Bluetoothイヤホン',
    tws13: 'H35<br> 充電ケースディスプレイ',
    speaker1: 'BT-2928<br>Bluetoothスピーカー',
    speaker2: 'BT-2612<br>Bluetoothスピーカー',
    speaker3: 'BT-2602 RGB<br>Bluetoothスピーカー',
    others1: 'F11<br>ネックファン',
    others2: 'TP107C1<br> GaN（ガン）充電器',
    others3: 'TP65C2U1<br> GaN（ガン）充電器',
    others4: 'OJD-88<br> 4-in-1ワイヤレスチャージャー',
    others5: 'KR8<br>ネックファン',
    others6: 'S70<br> 3WAYシェーバー',
    others7: 'H13<br> コードレス折りたたみ掃除機',
    others8: 'YL-001<br>加湿器',
    others9: 'P4<br>アップルペンシル',
    others10: 'P3<br>アップルペンシル',
    others11: 'E03<br>アップルペンシル',
    others12: 'MV53 <br>高速ヘアドライヤー',
    others13: 'ML-JB-01 <br>トレートヘアアイロン',
    others14: 'ZY-3101 <br>車用掃除機',
    others15: 'WETAG <br>紛失防止タグ',
    others16: 'S108 <br>シェーバー',
    others17: 'S109 <br>3WAYシェーバー',
  },
  detail: {
    featuresTitle: '商品のセールスポイント',
    ariaPrev: 'Previous image',
    ariaNext: 'Next image',
    thumbCarousel: 'Product thumbnails',
    p1: {
      name_html: 'B18<br/>モバイルバッテリー',
      features_html:
        '3本のケーブル内蔵、USB-Aポート×2<br/>大画面デジタル表示、ストラップ付き',
      specs: [
        { label: '型番', value: 'B18' },
        { label: '材質', value: 'PC + ABS' },
        { label: '電池', value: '146074*1' },
        { label: 'Type-C入力 / マイクロUSB入力', value: '5V 2A' },
        { label: 'USBケーブル内蔵で入力', value: '5V 2A' },
        { label: 'USB1/2ポート出力', value: '5V 2A' },
        { label: '内蔵ライトニングケーブルで出力', value: '5V 2A' },
        { label: 'Type-内蔵Type-Cケーブルで出力', value: '5V2A' },
      ],
    },
    p2: {
      name_html: 'S9 スマートウォッチ',
      features_html: '',
      specs: [
        { label: 'ディスプレイサイズ ', value: '2.01インチ' },
        { label: 'ピクセル', value: '240*296' },
        { label: 'ディスプレイ種類', value: 'IPS TFT' },
        { label: 'PPI', value: '190' },
        { label: '容量（電流*時間）', value: '1000mAh' },
        { label: '電力量 (Wh) = 容量 (Ah)*電圧 (V)', value: '3.8Wh' },
        { label: '使用時間', value: '20-30日間' },
        { label: '待機時間', value: '80-120日間' },
        { label: '本体', value: 'PC + ABS' },
        { label: 'ベルト', value: 'シリコン' },
        { label: 'CPU', value: 'JL7074A5（ジェリ製）' },
        { label: 'Bluetooth', value: 'Bluetooth5.3 + EDR' },
        { label: 'タッチ', value: '一体型タッチパネルOGS' },
        { label: '対応OS', value: 'Android 6.0以上' },
        { label: '対応OS', value: 'iOS 9.0以上' },
      ],
    },
    p3: {
      name_html: 'H15<br/> Bluetoothイヤホン',
      features_html:
        '耳が詰まった感じがしないし、どんな耳の形にも合いやすくて、メガネをかけていても快適。耳の穴が蒸れない、落ちにくい、装着感が快適、屋外での使用により安全',
      specs: [
        { label: 'ANC/ENC', value: 'N/A' },
        { label: '防水等級', value: 'IPX4' },
        { label: 'ステレオシステム', value: 'ステレオ' },
        { label: 'Bluetoothバージョン', value: 'V6.0' },
        { label: 'Bluetooth有効距離', value: '10メートル以下' },
        { label: '周波数レスポンス', value: '20Hz - 20KHz' },
        { label: '充電ポート', value: 'Type-C' },
        { label: '受信感度 (TYP)', value: '-94dbm' },
      ],
    },
    p4: {
      name_html: 'BX09<br/> Bluetoothイヤホン',
      features_html:
        '最新Bluetooth 5.3搭載、低消費電力＆高音質＆高性能スピーカーを採用，クリアな通話と迫力の立体音響,大容量バッテリーにより長時間の通話・音楽再生が可能',
      specs: [
        { label: 'イヤホンサイズ', value: '30.7*18.7*19.2mm' },
        { label: '充電ケースサイズ', value: '57.0*46.0*23.5mm' },
        { label: 'Bluetooth', value: 'Bluetooth V5.3' },
        { label: '伝送距離', value: '> 10メートル' },
        { label: '待機時間', value: '約90日間' },
        { label: 'ケース素材', value: 'ABS' },
        { label: '充電ケースの電池容量', value: '851327/300mAh' },
        { label: 'Bluetooth動作周波数', value: '2.402GHz-2.480GHz' },
      ],
    },
  },
}
